import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'

import useDemographicData from '../useDemographicData'

const DemographicEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const demographicData = useDemographicData(widgetId)
  const { t } = useTranslation()

  if (demographicData.isEmpty) return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  return children
}

export default DemographicEmptyResultGuard
